import store from '@/store';
import { creditReportRepository } from '@/forms/api/repository-factory';
import getValueByFieldName from '@/forms/helpers/get-value-by-field-name';
import FIELD_NAMES from '@/forms/constants/field-names';
import callApi from '@/lib/helpers/call-api';

const creditScoreDOBDateFormat = function (dob1) {
  var date = new Date(dob1);
  var extractedDate = date.getDate();
  var newdobDate = extractedDate < 10 ? '0' + '' + extractedDate + '' : '' + extractedDate + '';
  var extractedMonth = date.getMonth() + 1;
  var newdobMonth = extractedMonth < 10 ? '0' + '' + extractedMonth + '' : '' + extractedMonth + '';
  var extractedYear = date.getFullYear();
  return '' + newdobDate + '' + '' + newdobMonth + '' + '' + extractedYear + '';
}
const creditScorePassportDateFormat = function (date) {
  var datetoConvert = new Date(date);
  var dobDate = datetoConvert.getDate();
  var dobMonth = datetoConvert.getMonth() + 1;
  var dobYear = datetoConvert.getFullYear();
  var newdobDate = dobDate < 10 ? '0' + '' + dobDate + '' : '' + dobDate + '';
  var newmonthDate = dobMonth < 10 ? '0' + '' + dobMonth + '' : '' + dobMonth + '';

  return newdobDate + newmonthDate + dobYear;
};
const getPayload = () => {
  const { values } = store.state.formData;
  const { appId, cifnumber } = store.state;
  const firstName = getValueByFieldName(values, FIELD_NAMES.firstName);
  const lastName = getValueByFieldName(values, FIELD_NAMES.lastName);
  const dob = creditScoreDOBDateFormat(getValueByFieldName(values, FIELD_NAMES.birthDate));
  const gender = getValueByFieldName(values, FIELD_NAMES.gender);
  let passportExpiryDate, passportNumber;
  if (getValueByFieldName(values, FIELD_NAMES.passportNumber)) {
    passportNumber = getValueByFieldName(values, FIELD_NAMES.passportNumber);
  }
  if (getValueByFieldName(values, FIELD_NAMES.passportExpiryDate)) {
    passportExpiryDate = creditScorePassportDateFormat(getValueByFieldName(values, FIELD_NAMES.passportExpiryDate));
  }
  const nationality = getValueByFieldName(values, FIELD_NAMES.nationality);
  const fixedIncome = getValueByFieldName(values, FIELD_NAMES.fixedIncome);
  const emiratesID = getValueByFieldName(values, FIELD_NAMES.emiratesID);
  const phone = getValueByFieldName(values, FIELD_NAMES.phoneNumber);


  return {
    "app-id": appId,
    "cif-number": cifnumber,
    "first-name": firstName,
    "last-name": lastName,
    "full-name": firstName + ' ' + lastName,
    "gender": gender,
    "dob": dob,
    "nationality": nationality,
    "emirates-id": emiratesID,
    "income": '' + fixedIncome + '',
    "verified-income": "0",
    "passport-number": typeof !passportNumber !== 'undefined' ? passportNumber : "",
    "passport-expiry": typeof passportExpiryDate !== 'undefined' ? passportExpiryDate : "",
    "previous-passport-number": "",
    "mobile-number": "971" + phone,
    "subject-id": null
  };
};

export default {
  async creditReport(currentStep, callbacks) {
    const { form } = currentStep;
    let response = false;
    response = await callApi({
      callbacks,
      form,
      formElement: currentStep,
      apiCall: creditReportRepository.creditReport,
      payload: getPayload(),
    });

  }
};
